import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { th } from 'date-fns/locale';
import { PopoverRef } from 'src/@vex/components/popover/popover-ref';
import { PopoverService } from 'src/@vex/components/popover/popover.service';
import { MultiOpreationModel } from 'src/app/interface/dto';
import { ExamScheduleService } from 'src/app/services/exam-schedule-service';
import { ExamService } from 'src/app/services/exam-service.service';
import { SnackbarService } from 'src/app/services/snackbar.service';

@Component({
  selector: 'app-ImportCandidatesData',
  templateUrl: './ImportCandidatesData.component.html',
  styleUrls: ['./ImportCandidatesData.component.css']
})
export class ImportCandidatesDataComponent implements OnInit {
  reImport: boolean;

  constructor(private popoverRef: PopoverRef<ImportCandidatesDataComponent>, private examService: ExamService, private examSchService: ExamScheduleService, private snackBar: SnackbarService,) { }

  ngOnInit() {
  }

  async importData() {
    try {
      let selectedExamID = this.examService.selectedExamIds[0];
      let selectedCandidate = Array.isArray(this.examSchService.selectedIds) && this.examSchService.selectedIds.length > 0
        ? this.examSchService.selectedIds.map(x => parseInt(x))[0]
        : 0;
      let data: MultiOpreationModel = {
        examinationID: this.examService.selectedExamIds.length > 1 ? 0 : selectedExamID,
        examinationScheduleID: this.examSchService.selectedIds.length > 1 ? 0 : selectedCandidate,
        reImport: this.reImport, 
        selectAllSch: this.examSchService.selectAll, 
        selectAllExam: this.examService.selectAll,
        examIds: this.examService.selectedExamIds,
        scheduleIds: this.examSchService.selectedIds.map(x => parseInt(x)),
      };
      await this.examService.importCandidatesData(data).then((res: any) => {
        this.snackBar.success('Candidates Data Imported Successfully');
        this.examService.reloadGrid.next(true);
        this.examSchService.reloadGrid.next(true);
        this.close();
      });
    } catch (error) {
      this.snackBar.error('Failed to import candidates data. Please try again later.');
      console.error(error);
      return;

    }

  }
  close() {
    this.popoverRef.close();
  }
}
